/**
 * API Configuration for different environments
 *
 * This file provides environment-specific configuration for API URLs.
 * - Development: Uses localhost with port
 * - Production: Uses production domain without port
 */

// Base URLs for different environments
const API_CONFIG = {
  // Development environment - empty string uses relative URLs,
  // proxied to backend via Vite dev server proxy config
  development: {
    baseUrl: "",
  },
  // Production environment - empty string uses relative URLs,
  // proxied to backend via Nginx
  production: {
    baseUrl: "",
  },
};

// Determine current environment using Vite's import.meta.env
const currentEnv = import.meta.env.PROD ? "production" : "development";

// Export the configuration for the current environment
export const apiConfig = {
  baseUrl: API_CONFIG[currentEnv].baseUrl,
};

// Helper function to build full API URLs
export const buildApiUrl = (path: string): string => {
  // Ensure path starts with a slash
  const formattedPath = path.startsWith("/") ? path : `/${path}`;
  return `${apiConfig.baseUrl}${formattedPath}`;
};

export default apiConfig;
